const getUser = state => state.user;

export default {
    getUser,
}
